import VAutocomplete from './VAutocomplete'

export { VAutocomplete }
export default VAutocomplete



// WEBPACK FOOTER //
// ../../../src/components/VAutocomplete/index.ts